(function () {
    'use strict';

    angular
        .module('actionPlanCriteriaEditModule')
        .controller('ActionPlanCriteriaEditController', Controller);

    Controller.$inject = ['$scope', '$state', '$stateParams', 'historyCtxtService', 'actionPlan', 'actionPlanCriteria'];

    function Controller($scope, $state, $stateParams, historyCtxtService, actionPlan, actionPlanCriteria) {

        // Action Plan Criteria 
        $scope.actionPlanCriteria = actionPlanCriteria;
        $scope.actionPlan = actionPlan;

        $scope.goToActionPlan = function () {
            
            if ($stateParams.ctxStateName) {
                historyCtxtService.goToState('recommendation.edit.actionPlan.edit',
                   { ActionPlanID: actionPlan.ActionPlanID },
                   $stateParams.ctxStateName,
                   $stateParams.ctxItem
                );

                return;
            }

            historyCtxtService.goToState('recommendation.edit.actionPlan.edit',
                { ActionPlanID: actionPlan.ActionPlanID },
                'recommendation.edit.actionPlan.edit',
                actionPlan
            );

        }

    }
})();